import {
	Chip,
	TextField
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { useContext, useEffect, useState } from 'react';
import toastError from '../../errors/toastError';
import api from '../../services/api';
import { SaleFunnelModal } from "../SalesFunnelModal"
import IconButton from "@material-ui/core/IconButton";
import { Can } from "../../components/Can";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import { ModalPadrao } from "../../components/modalPadrao";
import { AuthContext } from "../../context/Auth/AuthContext";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
	box: {
		backgroundColor:
			theme.palette.type === "dark"
				? "#121212"
				: "#ffffff"
	}
}));

export function SalesFunnelSwitcher({ onChange, companyId ,OnCreateNewFunnel}) {
	const [funnels, setFunnels] = useState([]);
	const [selected, setSelected] = useState(null);
	const [inputValue, setInputValue] = useState("");
	const [modalName, setModalName] = useState("");
	const [modalOpen, setModalOpen] = useState(false);
	const [modalId, setmodalId] = useState(0);
	const [modalDelete, setModalDelete] = useState(false);
	const [idDelete, setIdDelete] = useState(0);
	const [elementvisible, setElementvisible] = useState(false);

	const { user } = useContext(AuthContext);
	const userId = user?.profile !== "admin" ? user?.id : undefined;

	const classes = useStyles();
	useEffect(() => {
		async function fetchData() {
			await loadFunnels();
		}
		fetchData();
	}, []);

	const loadFunnels = async (v) => {
		try {
			const { data } = await api.get("/sales-funnel",{
				params: {
					requestUserId: userId
				}
			});
			const formattedData = user.profile === "admin"
				? [...data, { id: -1, name: "+ Novo Funil", isAction: true }]
				: [...data];

			setFunnels(formattedData);
			if (v) {
				const foundFunnel = formattedData.find(f => f.name === v);
				if (foundFunnel) {
					onChange(foundFunnel.name);
					handleChange(foundFunnel);
				} else {
					setSelected(null);
					setInputValue("");
					onChange(undefined);
					handleChange(undefined);
				}
			}
			else if (window.location.hash && window.location.hash !== '#') {
				const funnelId = window.location.hash.replace('#', '');
				const foundFunnel = formattedData.find(f => f.id.toString() === funnelId);
				if (foundFunnel) {
					onChange(foundFunnel.name);
				} else {
					window.history.replaceState(null, document.title, window.location.pathname + window.location.search);
				}
			} else if (data.length === 1) {
				handleChange(data[0]);
			}
		} catch (err) {
			toastError(err);
		}
	};

	const handleChange = (value) => {
		if (!value) return;
		if (value.id === -1) {
			setModalName(value.inputValue);
			setmodalId(0);
			setModalOpen(true);
			return
		}
		window.location.hash = `#${value.id}`;
		setSelected(null);
		setInputValue("");
		onChange(value.name);
	};

	const modalClose = async (v) => {
		if (v && typeof v === "string") {
			await loadFunnels(v);
			await onChange(v);
		}
		setModalOpen(false);
		OnCreateNewFunnel();
	};

	const handleDelete = async (id) => {
		try {
			if (selected && selected.id === id) {
				setSelected(null);
				setInputValue("");
				window.location.hash = "#";
			}
			await api.delete(`/sales-funnel/${id}`);
			loadFunnels();
		} catch (err) {
			toastError(err)
		}
		OnCreateNewFunnel();
	}

	useEffect(() => {
		const element = document.getElementById("sales-funnel-switcher-div");

		if (!element) return;

		const observer = new IntersectionObserver(([entry]) => {
				setElementvisible(entry.isIntersecting);
		});
		observer.observe(element);
		return () => observer.disconnect();
	}, []);

	useEffect(() => {
		if (elementvisible) {
			loadFunnels();
		}
	}, [elementvisible]);

	if (user.profile === "admin") {
		return (
			<div id="sales-funnel-switcher-div" className={classes.box}>
				<Autocomplete
					size="medium"
					open={elementvisible}
					forcePopupIcon={false}
					disableCloseOnSelect={elementvisible}
					options={funnels}
					value={selected}
					onChange={(e, v) => handleChange(v)}
					inputValue={inputValue}
					onInputChange={(event, newValue) => {
						setInputValue(newValue);
					}}
					filterOptions={(options, params) => {
						const filtered = options.filter((option) =>
							option.name.toLowerCase().includes(params.inputValue.toLowerCase())
						);

						if (filtered.length === 0 && params.inputValue.trim() !== "") {
							filtered.push({
								id: -1,
								name: `+ Criar novo funil "${params.inputValue.trim()}"`,
								inputValue: params.inputValue.trim(),
								isAction: true,
							});
						}
						return filtered;
					}}
					getOptionLabel={(option) => option.name}
					className="w-full"
					renderInput={(params) => (
						<TextField
							{...params}
							variant="outlined"
							label="Funil de vendas"
							className="w-full"
						/>
					)}
					renderOption={(option) => (
						<div className="flex items-center justify-between w-full">
							<span>{option.name}</span>
							{option.isAction && <Chip label="Novo" color="primary" size="small" />}
							{!option.isAction && <div>
								<IconButton
									size="small"
									onClick={() => {
										setmodalId(option.id);
										setModalName(option.name);
										setModalOpen(true);
									}}
									className="hover:bg-blue-100"
								>
									<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
										<path d="M19.14 12.94c.04-.31.06-.63.06-.94 0-.31-.02-.63-.06-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.04.31-.06.63-.06.94s.02.63.06.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z" />
									</svg>
								</IconButton>
								<Can role={user.profile}
									perform={"salefunnel-page:deleteFunnel"}
									yes={() => (
										<IconButton
											size="small"
											onClick={(e) => {
												e.stopPropagation();
												setIdDelete(option.id)
												setModalDelete(true);
											}}
											className="hover:bg-red-100"
										>
											<DeleteOutlineIcon className="text-red-600" />
										</IconButton>
									)}
								/>
							</div>}
						</div>
					)
					}
				/>
				{modalOpen && (
					<SaleFunnelModal
						nameFunnel={modalName}
						modalOpen={modalOpen}
						modalClose={modalClose}
						modalId={modalId}
					/>
				)}
				{<ModalPadrao
					type={"excluir"}
					messagePrincipal={"O funil de vendas e todos os os seus dados serão excluídos permanentemente e não poderão ser recuperados. Tem certeza de que deseja continuar?"}
					open={modalDelete}
					onClose={() => setModalDelete(false)}
					onConfirm={() => handleDelete(idDelete)}
				>
				</ModalPadrao>
				}
			</div>
		)
	} else {
		return (<div id="sales-funnel-switcher-div" className="w-full">
			<Autocomplete
				size="medium"
				open={elementvisible}
				forcePopupIcon={false}
				disableCloseOnSelect={elementvisible}
				options={funnels}
				value={selected}
				onChange={(e, v) => handleChange(v)}
				inputValue={inputValue}
				onInputChange={(event, newValue) => {
					setInputValue(newValue);
				}}
				getOptionLabel={(option) => option.name}
				className="w-full"
				renderInput={(params) => (
					<TextField
						{...params}
						variant="outlined"
						label="Funil de vendas"
						className="w-full"
					/>
				)}
			/>

		</div>
		);
	}

}
